import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from '../styles.module.scss';
import { I_TripType } from '@Redux/search/interfaces';
import { setTagFiltersShow } from '@Redux/search/actions';
import { RootState } from '@Redux/search/store';
import * as Tag from '@components/Common/Tag';

interface I_Props {
    tripTypes: I_TripType[];
    title: string;
}

const TripTypeList: React.FC<I_Props> = ({ tripTypes, title }) => {
    const moduleName = 'tripTypeList';
    const { TagFiltersShow } = useSelector((state: RootState) => state.search);
    const dispatch = useDispatch();

    const checkFiltersShow = (type: string) => {
        const newArr = JSON.parse(JSON.stringify(TagFiltersShow));
        const selected = newArr.indexOf(type);
        if (selected === -1) {
            newArr.push(type);
        } else {
            newArr.splice(selected, 1);
        }
        return newArr;
    };

    return (
        <div className={styles[`${moduleName}`]}>
            <div className={styles.ListTile}>
                <span>{title}</span>
            </div>
            <ul className={styles.ListContent}>
                {tripTypes.map((item) => {
                    const selectedIdx = TagFiltersShow.indexOf(item.TypeCode);

                    return (
                        <li
                            key={item.TypeCode}
                            className={styles.Tagwrap}
                            onClick={() => {
                                const newFiltersShow = checkFiltersShow(item.TypeCode);
                                dispatch(setTagFiltersShow(newFiltersShow));
                            }}
                        >
                            <Tag.Selectable
                                text={item.TypeName}
                                tripType={item.TypeCode}
                                isActive={selectedIdx !== -1}
                            />
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default React.memo(TripTypeList);
